/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Avatar, Box, Grid, Typography } from '@mui/material';
import CustomModal from '../../CustomModal/CustomModal';
import { fonts, themes } from '../../../themes/themes';
import CustomPlainCardTile from '../../../../common/components/CustomPlainCardTile/CustomPlainCardTile';
import InsuranceCard from '../../../components/InsuranceCard/InsuranceCard';
import _ from 'lodash';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import CardforInsuranceList from '../../../components/CardforInsurance/CardforInsuranceList';
import AddInsuranceController from '../AddInsurance/AddInsuranceController';

import EditInsuranceController from '../EditInsurance/EditInsuranceController';
import { toast } from 'react-hot-toast';
import ActivedocCard from '../../../components/ActivedocCard';
import Warning from '../../WarningModal/Warning';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  setExpiryInsuranceAttachedDoc: (id: number) => void;
  insuranceList: any;
  setDocsIdFordeletion: (id: number) => void;
  trans?: any;
}
const DepInsurancePresenter = ({
  isModalOpen,
  closeModal,
  insuranceList,
  setDocsIdFordeletion,
  setExpiryInsuranceAttachedDoc,
  trans,
}: ModalProps) => {
  const [addDepInsuranceModal, showAddDepInsuranceModal] = useState(false);
  const [editDepInsurance, seteditDepInsurance] = useState([]);
  const [editDepInsuranceModal, setEditDepInsuranceModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteInsurId, setDeleteInsurId] = useState<number>(0);
  const [title, setTitle] = useState();

  const handleViewDownload = (id: number) => {
    if (id != null) {
      setExpiryInsuranceAttachedDoc(id);
    } else {
      toast.error(trans('There is no Attachments!'));
    }
  };
  const handleEditInsurance = (activedepInsur: any) => {
    seteditDepInsurance(activedepInsur);
    setEditDepInsuranceModal(true);
  };
  const handleInsurDeleteModal = (activedepInsur: any) =>{
    setOpenDeleteModal(true)
    setDeleteInsurId(activedepInsur?.activedepInsur?.id)
    setTitle(activedepInsur?.doc_type)
  }
  const handleExpInsurDeleteModal = (insurance: any) =>{
    setOpenDeleteModal(true)
    setDeleteInsurId(insurance?.insurance?.id)
    setTitle(insurance?.doc_type)
  }
  const handleDeleteInsurance = () => {
    setDocsIdFordeletion(deleteInsurId);
  };
  return (
    <>
      <CustomModal
        isModalOpen={isModalOpen}
        modalHeight="650px"
        modalWidth="1000px"
      >
        <Grid container spacing={2}>
          <Grid item style={{ marginTop: '0.5em' }}>
            <i
              className="las la-arrow-left"
              style={{ color: themes.primary, cursor: 'pointer' }}
              onClick={closeModal}
            ></i>
          </Grid>
          <Grid item>
            <Avatar src={insuranceList?.photo} />
          </Grid>
          <Grid item>
            <Typography
              style={{
                fontFamily: 'Lato',
                fontSize: '0.9em',
                fontWeight: 'bold',
              }}
            >
              {insuranceList
                ? insuranceList?.first_name + ' ' + insuranceList?.last_name
                : ''}
            </Typography>
            <Typography
              style={{
                fontFamily: 'Lato',
                fontSize: '0.7em',
                color: '#575757',
              }}
            >
              {insuranceList ? insuranceList?.relationship_type?.name : ''}
            </Typography>
          </Grid>
        </Grid>
        <Box style={{ marginBottom: '24px' }} />
        <Grid container spacing={2}>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <Box
              style={{
                borderRadius: '15px',
                border: '1px solid #0000001F',
              }}
            >
              <ActivedocCard
                card_title={trans('Active Insurance')}
                card_subtitle={`${trans('Total')}: ${insuranceList
                  ?.active_dependent_insurances?.length}`}
                card_height="310px"
                onClick={() => {
                  showAddDepInsuranceModal(true);
                }}
              >
                {insuranceList?.active_dependent_insurances?.length > 0 ? (
                  _.map(
                    insuranceList?.active_dependent_insurances,
                    (activedepInsur: any) => {
                      return (
                        <CardforInsuranceList
                          tile_value={
                            activedepInsur ? activedepInsur?.insurers?.name : ''
                          }
                          subtitle1={trans('Policy No')}
                          PolicyNo={
                            activedepInsur ? activedepInsur.policy_number : ''
                          }
                          subtitle2={trans('Amount')}
                          amount={
                            activedepInsur ? `${activedepInsur.amount}` : ''
                          }
                          Issuetitle={trans('Start Date')}
                          IssueDate={
                            activedepInsur ? activedepInsur.start_date : ''
                          }
                          Expirytitle={`| ${trans('End Date')}`}
                          ExpDate={
                            activedepInsur ? activedepInsur.expiry_date : ''
                          }
                          onEdit={() => handleEditInsurance(activedepInsur)}
                          onDelete={() => handleInsurDeleteModal({activedepInsur,doc_type:"Insurance Document"})}
                          onView={() =>
                            handleViewDownload(
                              activedepInsur?.dependent_insurance_documents[0]
                                ?.dependent_insurance_id,
                            )
                          }
                        />
                      );
                    },
                  )
                ) : (
                  <Grid container style={{ marginBottom: '4.4em' }}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <img src={emptyIcon} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.title,
                          color: themes.blackDefault,
                          fontWeight: 'bold',
                        }}
                      >
                        {trans('Not Added')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.subtitle,
                          color: themes.defaultIcon,
                        }}
                      >
                        {trans(
                          'Currently you haven’t any Active Insurance Documents',
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </ActivedocCard>
            </Box>
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6}>
            <Box
              style={{ borderRadius: '15px', border: '1px solid #0000001F' }}
            >
              <CustomPlainCardTile
                card_title={trans('Expired Insurance')}
                title_color="#F44336"
                card_height="311px"
                card_subtitle={`${trans('Total')}: ${insuranceList
                  ?.expired_dependent_insurances?.length}`}
              >
                {insuranceList?.expired_dependent_insurances?.length > 0 ? (
                  _.map(
                    insuranceList?.expired_dependent_insurances,
                    (insurance: any) => {
                      return (
                        <InsuranceCard
                          tile_value={
                            insurance ? insurance?.insurers?.name : ''
                          }
                          subtitle1={trans('Policy No')}
                          IdentifierNo={
                            insurance ? insurance?.policy_number : ''
                          }
                          Issuetitle={trans('Issue')}
                          IssueDate={insurance ? insurance?.start_date : ''}
                          Expirytitle={trans('Expired')}
                          ExpDate={insurance ? insurance?.expiry_date : ''}
                          onDelete={() => handleExpInsurDeleteModal({insurance,doc_type:"Insurence Documnet"})}
                          onView={() =>
                            handleViewDownload(
                              insurance?.dependent_insurance_documents[0]
                                .dependent_insurance_id,
                            )
                          }
                        />
                      );
                    },
                  )
                ) : (
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <img src={emptyIcon} />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.title,
                          color: themes.blackDefault,
                          fontWeight: 'bold',
                        }}
                      >
                        {trans('Not Added')}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: fonts.fontFamily,
                          fontSize: fonts.subtitle,
                          color: themes.defaultIcon,
                        }}
                      >
                        {trans(
                          'Currently you haven’t any Expired Insurance Documents',
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </CustomPlainCardTile>
            </Box>
          </Grid>
        </Grid>
      </CustomModal>
      <Warning 
        openmodal={OpenDeleteModal}
        oncancel={() => setOpenDeleteModal(false)}
        infoMessage={trans(`Are You Deleting ${title}?`)}
        onconfirm={handleDeleteInsurance}
      />
      {addDepInsuranceModal && (
        <AddInsuranceController
          mainModel={closeModal}
          insuranceList={insuranceList}
          isModalOpen={addDepInsuranceModal}
          closeModal={() => {
            // closeModal();
            showAddDepInsuranceModal(false);
          }}
          trans={trans}
        />
      )}
      {editDepInsuranceModal && (
        <EditInsuranceController
          mainModel={closeModal}
          editedData={editDepInsurance}
          isModalOpen={editDepInsuranceModal}
          closeModal={() => setEditDepInsuranceModal(false)}
          trans={trans}
        />
      )}
    </>
  );
};
export default DepInsurancePresenter;
